// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Resources } from '@shared/localizations/Resources';
import { popupErrorHandler } from '@shared/utils/AppHandlers';
import DPProductTypeAndModifyQuantityTemplate from '@front/templates/DPProductTypeAndModifyQuantityTemplate.html';
import { DynPropertyControl } from '../elements/DynPropertyControl';
export class DPProductTypeAndModifyQuantity extends DynPropertyControl {
    constructor() {
        super();
    }
    getType() {
        return 'DPProductTypeAndModifyQuantity';
    }
    oninit() {
        super.oninit();
        this.on('terceraNumericInputClick', this.onInputClick);
    }
    oncomplete() {
        super.oncomplete();
        void this.set('MQNumericLink', this.Controls.MQNumeric);
        this.observe('dp.customLess', (n, o) => {
            const key = n ? 'general.trading.noQuantityAvailable' : 'UserControl.TerceraNumeric.ValueLessMin';
            void this.set('valueLessMinLocalKey', key).then(() => {
                if (!isNullOrUndefined(this.Controls.MQNumeric)) {
                    this.Controls.MQNumeric.onNeedUpdateValidationStateInfo();
                }
            });
        });
    }
    lostFocus() {
        if (!isNullOrUndefined(this.Controls.MQNumeric)) {
            if (popupErrorHandler.isShowed()) {
                popupErrorHandler.Hide(this.Controls.MQNumeric);
            }
        }
        super.lostFocus();
    }
    onInputClick() {
        if (!this.get('dp.enabled')) {
            void this.set('dp.enabled', true);
        }
    }
    localize() {
        const locKeyT = this.get('dp.localizationKey_type');
        const locKeyQ = this.get('dp.localizationKey_qty');
        void this.set({ prTypeLabel: Resources.getResource(locKeyT), mqLabel: Resources.getResource(locKeyQ) });
    }
}
DynPropertyControl.extendWith(DPProductTypeAndModifyQuantity, {
    template: DPProductTypeAndModifyQuantityTemplate,
    data: function () {
        return {
            prTypeLabel: 'Target product type',
            mqLabel: 'Modify Quantity',
            MQNumericLink: null,
            valueGreaterMaxLocalKey: 'general.trading.qtyMoreTodayTradedValue',
            valueLessMinLocalKey: 'UserControl.TerceraNumeric.ValueLessMin'
        };
    }
});
